import React from "react";
import { Link } from "react-router";

export default class PageFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let loggedInLinks = null;
        if (this.props.loggedIn && !window.location.href.includes("outdated")) {
            loggedInLinks = <Link to="/news">Nieuwsarchief</Link>;
        }

        return (
            <footer className="site-footer">
                <span>
                    Vragen? Neem contact op met NIBHV Support:{" "}
                    <a href="tel:010-2892888">
                        <i className="fa fa-phone" style={{ marginRight: "5px" }} />
                        010-2892888
                    </a>
                    <a href="mailto:support@nibhv.nl">
                        <i className="fa fa-envelope" style={{ marginRight: "5px" }} />
                        support@nibhv.nl
                    </a>
                </span>
                <span>
                    {loggedInLinks}
                    <Link to="/privacy">Privacy- en cookiebeleid NIBHV</Link>
                    <Link to="/terms-of-use">Gebruiksovereenkomst</Link>
                    <span>versie {COMMIT_HASH}</span>
                </span>
            </footer>
        );
    }
}
